import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/Documents';
import {
  form,
  newForm
} from '../Form/documents';
import { form as searchForm } from '../Form/Search/documents';

import { documents as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "document",
    pageTitle: strings.common.homepage.document,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_NYUKOM' // TODO
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.name) {
        result["name"] = search.name;
      }
      return result;
    },

    availableItemDisplay:['line'],
    itemDisplay: {
      line: {
        label: (item) => {
          return item.name;
          //item.message.replace(/(?<=\{).+?(?=\})/g, (param) => item.params[param])
        }
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.document,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "number",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.document.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (entity) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_USER'],
        editable: ['ROLE_NYUKOM'] // TODO
      }
    }
  },
  new: {
    pageTitle: strings.document.new.title,

    api: newItem,
    empty: {},
    form: newForm,
    onSubmit: (document) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
